module.exports = __webpack_public_path__ + "34c2ecbcdc85d325a29633abb3d0b993.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/burger.png
// module id = 193
// module chunks = 0